import map from 'lodash/map';
import range from 'lodash/range';

const getOptions = ({
  start,
  count,
  renderLabel,
  renderValue,
  fieldId,
  increment = 1,
}) => map(range(start, Math.ceil((count + 1) / increment)), (index) => ({
  id: `${fieldId}-${index * increment}`,
  value: renderValue(index * increment),
  label: renderLabel(index * increment),
}));

export default ({ fieldId, hourOptions, minuteOptions }) => ({
  hours: getOptions({
    fieldId,
    ...hourOptions,
    renderValue: (index) => index,
    renderLabel: (index) => `${String(index)} hrs`,
  }),
  minutes: getOptions({
    fieldId,
    ...minuteOptions,
    renderValue: (index) => index,
    renderLabel: (index) => `${String(index)} mins`,
  }),
});
